import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

const BasePaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  ...theme.typography.body2,
  textAlign: 'center',
}));

export default BasePaper;
